import React, { Fragment } from 'react';
import { Table, Popup, Loader, Header, Button } from 'semantic-ui-react';
import axios from 'axios';
import { HeaderCursor } from '../../../../Professor/ProfessorInputGrades/css';
import { Redirect } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

const NoDataMessage = () => <p>Nema aktivnih kandidata.</p>;

export default class CandidatesPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            candidates: [],
            loader: true,
            showCreateCandidate: false,
        };

        this.closeForm = this.closeForm.bind(this);
        this.getAllCandidates = this.getAllCandidates.bind(this);
        this.onDeleteCandidate = this.onDeleteCandidate.bind(this);
    }


    closeForm() {
        this.setState({
            showCreateCandidate: false,
            showCreateCandidateFromUNSA: false
        });
    }

    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');
        this.getAllCandidates();
    }

    onDeleteCandidate(candidateId) {
        this.setState({ currentCandidateId: candidateId, deleting: true });
        axios.delete(`equivalence/delete-candidate/${candidateId}/`).then(response => {
            this.getAllCandidates();
            this.setState({ currentCandidateId: null, deleting: false });
            toast('Uspješno ste izbrisali kandidata.');
        }).catch(err => {
            this.setState({ loader: false, deleting: false });

            if (err.response.data === 'This candidate has courses.') {
                toast('Nije moguće obrisati kandidata koji ima predmete.');
            } else {
                toast('Došlo je do greške, kandidat nije izbrisan!');
            }
        });
    }

    getAllCandidates() {
        this.setState({ loader: true });
        axios.get('/equivalence/in-progress').then(response => {
            this.setState({
                loader: false,
                candidates: response.data.map(el => ({
                    firstName: el.firstName,
                    lastName: el.lastName,
                    sourceStudyProgram: el.sourceStudyProgram,
                    targetStudyProgramId: el.targetStudyProgramId,
                    targetStudyProgramName: el.targetStudyProgramName,
                    targetStudyProgramBasicName: el.targetStudyProgramBasicName,
                    candidateId: el.candidateId,
                    status: el.status,
                    committeeDisplayName: el.committeeAcademicYear + ' ' + el.committeeType,
                    sourceUniversity: el.sourceUniversity,
                    sourceOrganizationalUnit: el.sourceOrganizationalUnit,
                    sourceDepartment: el.sourceDepartment,

                }))
            });
        }).catch(err => {
            this.setState({ loader: false });
            toast('Nije moguće dobaviti kandidate!');
        });
    }

    render() {
        if (this.state.showCandidateInfo === true) {
            return <Redirect push to={{ pathname: '/ekvivalencija-ispita/prikaz-kandidata/detalji', state: { student: 1 } }} />;
        }

        return (
            <div>
                { this.state.loader &&
                    <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> }
                {!this.state.loader &&

                    <Fragment> {this.state.candidates.length ?
                        <Table celled selectable compact >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                    <Table.HeaderCell>Prezime i ime</Table.HeaderCell>

                                    <Table.HeaderCell>
                                        <Header as="h4" image>
                                            <Header.Content>
                                                Univerzitet
                                                <Header.Subheader>sa kojeg prelazi</Header.Subheader>
                                            </Header.Content>
                                        </Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>
                                        <Header as="h4" image>
                                            <Header.Content>
                                                Fakultet
                                                <Header.Subheader>sa kojeg prelazi</Header.Subheader>
                                            </Header.Content>
                                        </Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell><Header as="h4" image>
                                        <Header.Content>
                                            Odsjek
                                            <Header.Subheader>sa kojeg prelazi</Header.Subheader>
                                        </Header.Content></Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell><Header as="h4" image>
                                        <Header.Content>
                                            Studijski program
                                            <Header.Subheader>sa kojeg prelazi</Header.Subheader>
                                        </Header.Content></Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell><Header as="h4" image>
                                        <Header.Content>
                                            Studijski program
                                            <Header.Subheader>na koji prelazi</Header.Subheader>
                                        </Header.Content></Header>
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>Komisija</Table.HeaderCell>
                                    <Table.HeaderCell />

                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {this.state.candidates.map((el, index) =>
                                    (<Table.Row
                                        key={index}
                                        style={HeaderCursor}
                                        onClick={(e) => {

                                        }}
                                    >
                                        <Table.Cell verticalAlign="middle">
                                            {index + 1}.
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.lastName} {el.firstName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.sourceUniversity}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.sourceOrganizationalUnit}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.sourceDepartment}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.sourceStudyProgram}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.targetStudyProgramBasicName + ' | ' + el.targetStudyProgramName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.committeeDisplayName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" textAlign="center">
                                            <Popup
                                                content="Detalji"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        // disabled={this.state.edit}
                                                        compact
                                                        basic="true"
                                                        circular
                                                        icon="align justify"
                                                        size="small"
                                                        color="blue"
                                                        onClick={() => {
                                                            localStorage.setItem('candidateId', el.candidateId);
                                                            localStorage.setItem('candidateEquivalenceStatus', el.status);
                                                            localStorage.setItem('candidateFirstName', el.firstName);
                                                            localStorage.setItem('candidateLastName', el.lastName);
                                                            localStorage.setItem('showAddButton', 'yes');
                                                            localStorage.setItem('targetStudyProgramId', el.targetStudyProgramId);
                                                            this.setState({ showCandidateInfo: true });
                                                        }}
                                                    />}
                                            />
                                            <Popup
                                                content="Brisanje"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={this.state.deleting && this.state.currentCandidateId !== el.candidateId}
                                                        compact
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="small"
                                                        color="red"
                                                        onClick={() => this.onDeleteCandidate(el.candidateId)}
                                                    />}
                                            />
                                        </Table.Cell>
                                    </Table.Row>))}
                            </Table.Body>

                        </Table>


                        : <NoDataMessage />
                    }
                    </Fragment>}

                <ToastContainer hideProgressBar />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CandidatesTab/CandidatesPreview.js